import React, { Component } from 'react';

import IconPie from '../../assets/icons/IconPie';
import IconPieBlue from '../../assets/icons/IconPieBlue';

class MasterDataDataGroupButton extends Component {
    render() {
        return (
            <div className="flex mb-3">
                <button
                    type="button"
                    id="btndatagroup"
                    className={this.props.dataScopePage
                        ? "rounded-full font-bold px-5 py-2 flex items-center bg-white text-darkblue border-2 border-white mr-3"
                        : "rounded-full font-bold px-5 py-2 flex items-center bg-blue-200 text-darkblue border-2 border-white mr-3"
                    }
                    onClick={() => this.props.handleDataGroup()}
                >
                    <div className="bg-darkblue rounded-full flex justify-center items-center h-5 w-5 p-1">
                        {this.props.dataScopePage ? <IconPie /> : <IconPieBlue />}
                    </div>
                    <div className="ml-1">
                        Data Group
                    </div>
                </button>
                <button
                    type="button"
                    id="btndatascope"
                    className={this.props.dataScopePage
                        ? "rounded-full font-bold px-5 py-2 flex items-center bg-blue-200 text-darkblue border-2 border-white"
                        : "rounded-full font-bold px-5 py-2 flex items-center bg-white text-darkblue border-2 border-white"
                    }
                    onClick={() => this.props.handleDataScope()}
                >
                    <div className="bg-darkblue rounded-full flex justify-center items-center h-5 w-5 p-1">
                        {this.props.dataScopePage ? <IconPieBlue /> : <IconPie />}
                    </div>
                    <div className="ml-1">
                        Data Scope
                    </div>
                </button>
            </div>
        );
    }
}

export default MasterDataDataGroupButton;